export function shortDateFormat(date) {
    var rawMonth = date.getMonth() + 1;
    var rawDay = date.getDate();
    return `${date.getFullYear()}-${rawMonth < 10 ? `0${rawMonth}` : rawMonth}-${rawDay < 10 ? `0${rawDay}` : rawDay}`
}